import { PropsWithChildren } from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { appConfig } from '@/config/app.ts'

const Metadata = ({ children }: PropsWithChildren) => {
  return <Helmet titleTemplate={`${appConfig.appName} | %s`}>{children}</Helmet>
}

export default Metadata
